// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1CvD9","savePackageButton":"ClientWallet_savePackageButton__8JzOo"};